<mat-card appearance="outlined" class="resource-page">
  <mat-card-header>
    <mat-card-title>Groupe {{group.group}}</mat-card-title>
    <button mat-icon-button color="primary" [disabled]="loading"
      [matTooltip]="selectedTab === 0 ? 'Ajouter un membre' : 'Ajouter une ressource'"
      [attr.aria-label]="selectedTab === 0 ? 'Ajouter un membre' : 'Ajouter une ressource'"
      (click)="selectedTab === 0 ? handleAddUserDialog() : handleAddResourceDialog()">
      <mat-icon>add</mat-icon>
    </button>
  </mat-card-header>
  <mat-card-content>
    @if (loading) {
      <div class="page-status" role="status">
        <mat-spinner [diameter]="32"></mat-spinner>
        <span>Chargement des données...</span>
      </div>
    } @else {
      <mat-tab-group [(selectedIndex)]="selectedTab" mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab label="Membres">
          <div class="table-scroll" role="region" aria-label="Membres du groupe" tabindex="0">
            <mat-table [dataSource]="userList">
              <ng-container matColumnDef="email">
                <mat-header-cell *matHeaderCellDef>Email</mat-header-cell>
                <mat-cell *matCellDef="let user">{{user.email}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="roles_list">
                <mat-header-cell *matHeaderCellDef>Rôles</mat-header-cell>
                <mat-cell *matCellDef="let user">
                  <mat-chip-set aria-label="Rôles">
                    @for (role of user.roles_list || []; track role) {
                      <mat-chip>{{role.name}}</mat-chip>
                    }
                  </mat-chip-set>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="delete">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let user">
                  <button mat-icon-button matTooltip="Retirer du groupe"
                    [attr.aria-label]="'Retirer ' + user.email + ' du groupe'"
                    (click)="handleDeleteUserFromGroupDialog(user.email)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="userListDisplayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: userListDisplayedColumns"></mat-row>
            </mat-table>
          </div>
          @if (userList.length === 0) {
            <p class="page-status">Aucun membre.</p>
          }
        </mat-tab>
        <mat-tab label="Ressources">
          <div class="table-scroll" role="region" aria-label="Ressources du groupe" tabindex="0">
            <mat-table [dataSource]="resourcesList">
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef>Ressource</mat-header-cell>
                <mat-cell *matCellDef="let resource">{{resource.name}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="delete">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let resource">
                  <button mat-icon-button matTooltip="Retirer du groupe"
                    [attr.aria-label]="'Retirer ' + resource.name + ' du groupe'"
                    (click)="handleDeleteResourceFromGroupDialog(resource.name)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="resourcesListDisplayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: resourcesListDisplayedColumns"></mat-row>
            </mat-table>
          </div>
          @if (resourcesList.length === 0) {
            <p class="page-status">Aucune ressource.</p>
          }
        </mat-tab>
      </mat-tab-group>
    }
  </mat-card-content>
</mat-card>